/**
 * Which books system a customer_bill_push row was delivered to. Every customer
 * is invoiced in Zoho AND pushed to Route Mobile's Odoo, where an Odoo customer
 * is exactly one Zoho customer; so one (customer, period) can hold a row of each
 * kind, and a single row always belongs to exactly one provider.
 */
export enum BillPushProvider {
  ZOHO = 'zoho',
  ODOO = 'odoo',
}

/**
 * The `billing-model` header of Route Mobile's centralised-billing API. Each
 * value creates its own Odoo invoice. We send the whole Zoho invoice, RCS
 * lines included, as one HELTAR_WBM invoice: one invoice per customer and
 * period, like Zoho. Route Mobile also offers 'heltar-rcs' for RCS on its own;
 * not used for now.
 */
export enum OdooBillingModel {
  HELTAR_WBM = 'heltar-wbm',
}

/**
 * Outcome of one Odoo invoice push.
 *
 * - CREATED: Route Mobile answered success; the invoice exists in Odoo and is
 *   never sent again for that period.
 * - FAILED: anything else (an error answer, an HTTP error, no answer); the
 *   period may be pushed again.
 */
export enum OdooPushStatus {
  CREATED = 'created',
  FAILED = 'failed',
}
